import { Directive, OnDestroy, QueryList, ViewChildren } from '@angular/core';
import { BaseComponent } from 'src/app/shared/base.component';

import { LazyLoaderDirective } from '../../shared/lazy-loader/lazy-loader.directive';

@Directive()
export abstract class MemberBaseComponent extends BaseComponent implements OnDestroy {

    @ViewChildren(LazyLoaderDirective) headers: QueryList<LazyLoaderDirective>;

    ngOnDestroy(): void {
        super.ngOnDestroy();
        this.subscriptions.forEach(subscription => {
            try{
            subscription.unsubscribe();
            } catch{}
        });
    }

}
